export const enClientPortalValuationDCFPage = {
    table: {
        columnLabels: {
            period: 'Period {{period}}',
            exit: 'Exit',
        },
        sections: {
            marketRent: 'Market rent',
            revenue: 'Revenue',
            costs: 'Costs',
            presentValueCalculation: 'Present value calculation',
        },
        rows: {
            grossRevenue: 'Gross revenue',
            totalCosts: 'Total costs',
            discountFactor: 'Discount factor',
            totalNetRevenue: 'Total net revenue',
            presentValue: 'Present value',
            terminalValue: 'Terminal value/perpetual annuity',
            presentValueTotal: 'Total present value',
            presentValueAfterTransactionCosts: 'Total present value without transaction costs',
            rounded: 'Rounded',
        },
    },
}
